export default "__VITE_ASSET__BVPbwNk5__"